import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Navigate } from 'react-router';

import { connect, useDispatch } from 'react-redux';

import * as statuses from 'constants/statuses';

import ErrorContainer from 'Containers/ErrorContainer';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import ScoringLoading from '../Scenes/ScoringLoading';

import { skincareLoadingContent } from 'assets/content/consultation/scoringLoading';

import * as consultationSelectors from 'dux/consultation/selectors';
import { fetchHairProfile, finishConsultation } from 'dux/consultation/thunks';

const SkincareResultsContainer = ({
  resultsError,
  resultsStatus,
  successUrl,
  answers,
  answersError,
  answersIsLoading,
  consultationCategory,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!answers) {
      dispatch(fetchHairProfile());
    }
  }, []);

  const [pastTimeout, setPastTimeout] = useState(false);
  const memoizedSetPastTimeout = useCallback(() => setPastTimeout(true), []);
  useEffect(() => {
    if (['idle', 'invalidated'].includes(resultsStatus)) {
      dispatch(finishConsultation(consultationCategory));
    }
  }, [resultsStatus, finishConsultation]);

  if (answersError) {
    return (
      <ErrorContainer
        error={resultsError}
        retry={() => dispatch(fetchHairProfile())}
        sentryMessage="Invalid state on SkincareResultsContainer"
      />
    );
  }

  if (answersIsLoading) {
    return <ConsultationLoading />;
  }

  if (!pastTimeout) {
    return (
      <ScoringLoading
        description={skincareLoadingContent.description}
        disclaimer={skincareLoadingContent.disclaimer}
        onAnimationDone={memoizedSetPastTimeout}
        reviews={skincareLoadingContent.reviews}
        title={skincareLoadingContent.title}
      />
    );
  }

  switch (resultsStatus) {
    case 'loading':
    case 'idle':
    case 'invalidated':
      return (
        <ScoringLoading
          description={skincareLoadingContent.description}
          disclaimer={skincareLoadingContent.disclaimer}
          onAnimationDone={memoizedSetPastTimeout}
          reviews={skincareLoadingContent.reviews}
          title={skincareLoadingContent.title}
        />
      );
    case 'success':
      return <Navigate replace to={successUrl} />;
    case statuses.ERROR:
    default:
      return (
        <ErrorContainer
          error={resultsError}
          retry={() => dispatch(finishConsultation(consultationCategory))}
          sentryMessage="Invalid state on SkincareResultsContainer"
        />
      );
  }
};

SkincareResultsContainer.propTypes = {
  resultsError: PropTypes.shape({}),
  resultsStatus: PropTypes.string.isRequired,
  successUrl: PropTypes.string.isRequired,
  answers: PropTypes.shape({
    diag_hair_texture: PropTypes.string,
  }),
  answersError: PropTypes.shape(),
  answersIsLoading: PropTypes.bool,
  consultationCategory: PropTypes.string.isRequired,
};

SkincareResultsContainer.defaultProps = {
  answers: null,
  resultsError: null,
  answersError: null,
  answersIsLoading: false,
};

export default connect(state => ({
  resultsError: consultationSelectors.getSkincareScoringError(state),
  resultsStatus: consultationSelectors.getSkincareScoringStatus(state),
  answers: consultationSelectors.getConsultationAnswers(state),
  answersError: consultationSelectors.getConsultationError(state),
  answersIsLoading: consultationSelectors.getIsConsultationLoading(state),
}))(SkincareResultsContainer);
